// 主要针对一些榜单的基础数据结构进行定义
export interface MemberProps {
  avatar: string
  id: number
  name: string
  zy_id: string
}
export interface ListItemType {
  member_info: MemberProps
  rank: number
  score: number
}
export const areaList = [0, 1, 2, 3, 4, 5, 6]
// 榜单奖励的通用接口 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=41442508
// 榜单奖励的通用数据格式
export interface reward_item_type {
  ranks: Array<number>
  item_list: Array<{img: string; desc: string}>
}
// 币商数据结构
export interface CoinSellerType {
  mid: number
  name: string
  show_id: string
  flag_url: string
  avatar: string
  coins_on_sale: number
  trade_times: number
  contact: string
  status: 0 | 1
  userPrivilegeSt?: {
    medals: Array<{
      id: number
      icon?: string
      dmkIcon?: string
      iconV2?: string
    }>
  }
}
// 产品系列需求常见member返回数据结构
export interface MemberSt {
  id: number //	用户id
  name: string // 用户昵称	是
  avatar: number //	用户头像id
  gender: number //	用户性别。1女，2男，3未知	是
  avatar_urls: {
    aspect_low: {
      urls: string[]
    }
    origin?: {
      urls: string[]
    }
  }
  show_id?: number //	用户展示ID
  zyid?: string
}

// 各种渠道绑定的类型 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92448874
export enum channel_type_enum {
  Identity = 1,
  Payoneer = 2,
  PayerMaxBank = 3,
  AirWallexBank = 4,
  PayerMaxFawry = 5,
  GCash = 7,
  公会长代收 = 8, // 公会长代收
  售卖薪资给币商 = 9,
  印尼DANA = 10,
  印尼Shpee = 11,
  埃及Vodafone = 12,
  埃及Etisalat = 13,
  埃及Orane = 14,
  泰国TrueMoney = 15,
  马来西亚TouchnGo = 16,
  阿联酋Payby = 17,
  印尼LinkAja = 18,
  印尼OVO = 19,
  印尼GoPay = 20,
  菲律宾Coins = 21,
  菲律宾PayMaya = 22,
  菲律宾GrabPay = 23,
  菲律宾Lazada = 24,
  越南ninePay = 25,
  土耳其Papara = 26,
  巴基斯坦JazzCash = 27,
  巴基斯坦Easypaisa = 28,
  印尼Doku = 29,
  USDTTRC20 = 30,
  paparaBank = 31,
  Xendit = 32,
  PayermaxBankMA = 33, // 摩洛哥
  PayermaxBankAE = 34, // 阿联酋
  PayermaxBankSA = 35, // 沙特
  PayermaxBankEG = 36, // 埃及
  Epay = 37,
  PayburgerBankTR = 40,
  Pix = 42, // 42 Pix 巴西支付渠道
  DreamoLatam = 43, // 43 dreamoLatam 拉美Dreamo合作方
  OPay = 44, // 44 OPay 尼日利亚渠道
  LaPay = 45, // 45 LaPay 打款合作方（英国打款合作方）
  线下支付 = 100,
  // HiyaCash = 100,
  他人代收 = 200, // 他人代收
  CombinedCash = 300,
  币商代收 = 400,
  转金币 = 1000,
  转币商金币 = 1001,
}
// 渠道相关内容+样式信息
export interface channel_type_style {
  channel_type?: channel_type_enum // 渠道类型
  channel_name: any // 渠道名称
  logo: string // logo
  theme_color: string
  border_color?: string // 正常情况跟theme_color一致
  name_color?: string
  desc_color?: string
  bg_color: string
  desc?: string
  status_icon?: string
  sign_status?: string // 注册状态
  show_status?: string // 展示的状态
  status_color?: string // 注册状态的颜色
  menu_type?: number // 2为有状态链接
}
// 渠道绑定状态 只针对payonner
export enum channel_bind_status_enum {
  未绑定 = 0,
  生效中 = 1,
  待确认 = 2,
  被拒绝 = 3,
  未找到 = 404,
}
// 除了payonner以外的渠道使用这个enum
export enum status_enum {
  普通 = 0,
  待审核 = 1,
  审核通过 = 2,
  驳回 = 3,
}
// meta 结构
export interface Meta {
  title?: string // 标题
  image?: string // 需要展示的图片
  imageWidth?: string // 设置图片的宽高
  imageHeight?: string // 设置图片的宽高
  description?: string // 需要展示的描述
  openApp?: string // openApp Url
  package?: string
  app?: string
}
